import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import {
  fetchInternshipApplicationDetails,
} from "../../lib/data";

import arrow from "../../images/svg/arrow-back.svg";
import Loader from "../Loader";

function Itdetails() {
  console.log("Itdetails component initialized");
  const [clicked, setClicked] = useState("bio");
  const [userDetails, setUserDetails] = useState({});
  const [showDownload, setShowDownload] = useState(false);
  const [downloadHtml, setDownloadHtml] = useState(null);
  const urlParams = new URLSearchParams(window.location.search);
  const user_id = urlParams.get("user");

  useEffect(() => {
    fetchInternshipApplicationDetails(user_id)
      .then((response) => {
        // console.log("Details Response:", response);
        const resp = response.data;
        // console.log("Resp body:", resp);

        if (resp.status === 200) {
          setUserDetails(resp.data);
        } else {
          console.warn("API Error or Status not 200", resp);
          // window.location.reload();
        }
      })
      .catch((err) => {
        console.log("Fetch Error:", err);
        if (err.response) {
          toast.error(err.response);
        } else {
          toast.error(
            "Something went wrong!!! Please make sure you have a good internet connection."
          );
        }
      });
  }, []);

  const downloadResp = (resp) => {
    setDownloadHtml(resp);
  };

  return (
    <div>
      {Object.keys(userDetails).length != 0 ? (
        <div className="dashboard-content">
          <ToastContainer closeButton={false} />
          <div
            className="dashboard-content-back"
            onClick={() => window.history.back()}
          >
            <img src={arrow} alt="back" />
            <p>Back</p>
          </div>
          <div className="disp-flex dashboard-content-detail-actions">
            <div></div>
            <h3>
              {userDetails.firstName} {userDetails.lastName}
            </h3>
          </div>
          <div className="dashboard-content-detail">
            <p
              className={
                clicked === "bio"
                  ? "dashboard-content-detail-p active"
                  : "dashboard-content-detail-p"
              }
              onClick={() => setClicked("bio")}
            >
              Bio Data
            </p>
          </div>
          {clicked === "bio" && (
            <div
              className="dashboard-content-form"
              ref={(response) => downloadResp(response)}
            >
              <form>
                <div className="dashboard-content-form-container">
                  <h5>Full Name</h5>
                  <p>{userDetails?.firstName} {userDetails?.lastName}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5>Email Address</h5>
                  <p>{userDetails?.email}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5>Phone Number</h5>
                  <p>{userDetails?.phoneNumber}</p>
                </div>

                <div className="dashboard-content-form-container">
                  <h5>Course</h5>
                  <p>{userDetails?.course}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5>School</h5>
                  <p>{userDetails?.institution}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5>Matric Number</h5>
                  <p>{userDetails?.matricNumber}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5>Accommodation</h5>
                  <p>{userDetails?.accommodation ? 'Yes' : 'None'}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5>Tution Fee</h5>
                  <p>{userDetails?.isPaid ? 'Paid' : 'Not Paid'}</p>
                </div>
                <div className="dashboard-content-form-container">
                  <h5>ID Card</h5>
                  <p>{userDetails?.idCardName}</p>
                </div>
              </form>
            </div>
          )}
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
}

export default Itdetails;
